import { render, staticRenderFns } from "./ModelPage.vue?vue&type=template&id=0e2323cb"
import script from "./ModelPage.vue?vue&type=script&lang=js"
export * from "./ModelPage.vue?vue&type=script&lang=js"
import style0 from "./ModelPage.vue?vue&type=style&index=0&id=0e2323cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports